import UserPayrollPermissionComponent from "../components/UserPayrollPermission";
import useUserPayrollPermission from "../hooks/useUserPayrollPermission";

function UserPayrollPermission() {
  const useUserPayrollPermissionProps = useUserPayrollPermission();
  return <UserPayrollPermissionComponent {...useUserPayrollPermissionProps} />;
}

export default UserPayrollPermission;
